export enum Color {
    Green = 'groen',
    Orange = 'oranje',
    Red = 'rood',
    Blue = 'blauw',
    Grey = 'grijs',
}

export enum HexColor {
    Green = '#5ECF09',
    Orange = '#F4A809',
    Red = '#D53119',
    Blue = '#255CFE',
    Grey = '#777777',
}
